import axios from "axios";
import { API_URL } from "../utils/constant";
// import Cookies from "universal-cookie";
import {
  LOOK_ALIKE_FETCHED,
  DOMAIN_SQUATING,
  LOOK_ALIKE_FETCHED_BY_ID,
  DOMAIN_SQUATING_TOTAL,
  DOMAIN_SQUATING_GRAPH,
  DOMAIN_SQUATING_DOMAIN,
  DOMAIN_SQUATING_UPDATE,
  FETCH_MOBILE_APP_UPDATE
} from "./index";
import { toastr } from "react-redux-toastr";



export const fetchDomainsById = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;


  if (props !== undefined) {
    axios
      .get(`${API_URL}/getScanDetailsById/${props}`)
      .then((response) => {
        dispatch({
          type: LOOK_ALIKE_FETCHED_BY_ID,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: LOOK_ALIKE_FETCHED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const updateDomainStatus = (status, _id, index, paramId, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios
    .post(`${API_URL}/updateDomainStatus`, {
      _id: _id,
      status: status,
      index: index,
      paramId: paramId,
    })
    .then((response) => {
      if (response.data.error) {
        toastr.error("Error", response.userMessage);
      } else {
        // toastr.success("Success", "Record updated.");
        dispatch({
          type: LOOK_ALIKE_FETCHED_BY_ID,
          payload: response.data,
        });
      }
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }

      dispatch({
        type: LOOK_ALIKE_FETCHED,
        payload: { error: true, userMessage: message },
      });
    });
};

export const domainSquating = (props, dispatch, page, category, subdomain, type,startDate,endDate, searchQuery, limit) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  if (props !== undefined) {
    dispatch({
      type: DOMAIN_SQUATING,
      payload: {},
    });
    axios
      .get(`${API_URL}/organisations/${props}/domainsquatting/delta?page=${page}&category=${category}&subdomain=${subdomain}&type=${type}&from=${startDate}&till=${endDate}&search=${searchQuery || ''}&limit=${limit || 10}`)
      .then((response) => {
        dispatch({
          type: DOMAIN_SQUATING,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: DOMAIN_SQUATING,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const domainSquatingAction = (props, dispatch, data, page, category, subdomain) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  if (props !== undefined) {
    axios
      .post(`${API_URL}/organisations/${props}/domainsquatting/action?page=${page}&category=${category}&subdomain=${subdomain}`, data)
      .then((response) => {
        dispatch({
          type: DOMAIN_SQUATING,
          payload: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.error("Error", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: DOMAIN_SQUATING,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const domainSquatingDomain = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  if (props !== undefined) {
    axios
      .get(`${API_URL}/organisations/${props}/domainsquatting/domains`)
      .then((response) => {
        dispatch({
          type: DOMAIN_SQUATING_DOMAIN,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: DOMAIN_SQUATING_DOMAIN,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const domainSquatingTotal = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  if (props !== undefined) {
    dispatch({
      type: DOMAIN_SQUATING_TOTAL,
      payload: {},
    });
    axios
      .get(`${API_URL}/organisations/${props}/domainsquatting/totals`)
      .then((response) => {
        dispatch({
          type: DOMAIN_SQUATING_TOTAL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: DOMAIN_SQUATING_TOTAL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const domainSquatingExcel = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  if (props !== undefined) {
    axios
      .get(`${API_URL}/organisations/${props}/domainsquatting/graph`)
      .then((response) => {
        dispatch({
          type: DOMAIN_SQUATING_GRAPH,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: DOMAIN_SQUATING_GRAPH,
          payload: { error: true, userMessage: message },
        });
      });
  }
};


export const takeDown = (formData, dispatch) => {
  const session = localStorage.getItem("session");
  
  // Set up axios headers for FormData
  const config = {
    headers: {
      'Authorization': `Bearer ${session}`,
      'Content-Type': 'multipart/form-data'
    }
  };
  
  return axios
    .post(`${API_URL}/ticket/getTakeDownRequest`, formData, config)
    .then((response) => {
      // Check response and show appropriate message
      if (response.data.error === false) {
        toastr.success("Success", response.data.userMessage || "Ticket created successfully.");
      } else {
        // toastr.error("Error", response.data.userMessage || "Failed to create ticket.");
      }
      
      // Dispatch based on module type
      const moduleName = formData.get('moduleName');
      if (moduleName === 'rogue_mobile_applications') {
        dispatch({
          type: FETCH_MOBILE_APP_UPDATE,
          payload: response.data,
        });
      } else {
        dispatch({
          type: DOMAIN_SQUATING_UPDATE,
          payload: response.data,
        });
      }
      
      // Return response for component to handle delta API refresh
      return response.data;
    })
    .catch((err) => {
      // var message = "Some server error has occurred.";
      // if (err.response && err.response.data) {
      //   message = err.response.data.userMessage || message;
      // }
      
      // toastr.error("Error", message);
      
      dispatch({
        type: DOMAIN_SQUATING_UPDATE,
        // payload: { error: true, userMessage: message },
      });
      
      // Re-throw error for component to handle
      // throw err;
    });
}

// Bulk takedown function for multiple records
export const bulkTakeDown = (organisationId, entries, dispatch) => {
  const session = localStorage.getItem("session");
  
  // Set up axios headers for FormData
  const config = {
    headers: {
      'Authorization': `Bearer ${session}`,
      'Content-Type': 'multipart/form-data'
    }
  };
  
  // Create FormData and append entries as JSON string
  const formData = new FormData();
  formData.append('entries', JSON.stringify(entries));
  
  return axios
    .post(`${API_URL}/ticket/${organisationId}/bulk-ticket-takedown`, formData, config)
    .then((response) => {
      if (response.data.error === false) {
        toastr.success("Success", response.data.userMessage || "Bulk takedown request created successfully.");
      } else {
        toastr.error("Error", response.data.userMessage || "Failed to create bulk takedown request.");
      }
      return response.data;
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response && err.response.data) {
        message = err.response.data.userMessage || message;
      }
      toastr.error("Error", message);
      return { error: true, userMessage: message };
    });
}

export const addLookalikeDomain = (props) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
  axios
    .post(`${API_URL}/lookalike-domains/createmanualrecord`, { ...props })
    .then((response) => {
      if (response.data.error)
        toastr.error("Error", response.data.userMessage);
      else
        toastr.success("Success", response.data.userMessage);
    })
    .catch((err) => {
      var message = "Some server error has occurred.";
      if (err.response) {
        message = err.response.data.userMessage;
      }
    });
}